// 로그인 화면 인증 흐름 순수 판정 — LoginPage에서 추출 (terra 리뷰 버그11·12)

export type NicknameCheckState = "idle" | "checking" | "available" | "taken";

export interface NicknameQueryResult {
  data: { id: string } | null;
  error: { message: string } | null;
}

/**
 * 닉네임 중복확인 응답 반영 판정 (terra 버그11)
 * - 요청 시점 닉네임 ≠ 현재 입력이면 stale 응답 → null(무시) — 늦은 응답이 새 닉네임에 반영되던 결함
 * - 쿼리 error면 idle — error 미확인으로 '사용 가능' 오표시되던 결함 (RLS/네트워크 오류 시)
 */
export function resolveNicknameCheck(
  requested: string,
  current: string,
  result: NicknameQueryResult,
): NicknameCheckState | null {
  if (requested !== current) return null;
  if (result.error) return "idle";
  return result.data ? "taken" : "available";
}

/**
 * 인증 진입점 단일 잠금 (terra 버그12) — 이메일 제출·소셜 OAuth 중 하나라도 진행 중이면
 * 다른 진입점 시작을 막는다 (이메일 가입 중 OAuth 시작 → 이중 인증 흐름 방지).
 */
export function isAuthBusy(emailLoading: boolean, oauthProvider: string | null): boolean {
  return emailLoading || oauthProvider !== null;
}
